import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER, Injector } from '@angular/core';
import { IonicApp, IonicModule } from 'ionic-angular';
import { Push } from '@ionic-native/push';
import { MyApp } from './app.component';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Geolocation } from '@ionic-native/geolocation';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CustomMissingTranslationHandler } from '../translate/CustomMissingTranslationHandler';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { InterceptorProvider } from '../providers/interceptor/interceptor';
import { IonicStorageModule } from '@ionic/storage';
import { UserProvider } from '../providers/user/user';
import { ConfigProvider } from '../providers/config/config';
import { InstituicaoProvider } from '../providers/instituicao/instituicao';
import { EventoProvider } from '../providers/evento/evento';
import { PessoaProvider } from '../providers/pessoa/pessoa';
import { BibliaProvider } from '../providers/biblia/biblia';
import { GrupoProvider } from '../providers/grupo/grupo';
import { MdaProvider } from '../providers/mda/mda';
import { CadastroProvider } from '../providers/cadastro/cadastro';
import { CultoProvider } from '../providers/culto/culto';
import { MensagemProvider } from '../providers/mensagem/mensagem';
import { OracaoProvider } from '../providers/oracao/oracao';
import { SharedModule } from '../shared/shared.module';
import { EnderecoProvider } from '../providers/endereco/endereco';
import { Camera } from '@ionic-native/camera';
import { NotTranslatedProvider } from '../providers/not-translated/not-translated';
import { DatePickerModule } from 'ion-datepicker-3';
import { SantoProvider } from '../providers/santo/santo';
import { SolicitacaoProvider } from '../providers/solicitacao/solicitacao';
import { MapaProvider } from '../providers/mapa/mapa';
import { NoticiaProvider } from '../providers/noticia/noticia';
import { Calendar } from '@ionic-native/calendar';
import { AplicativoProvider } from '../providers/aplicativo/aplicativo';
import { AnimationService } from 'css-animator';
import { EscalaProvider } from '../providers/escala/escala';
import { HinarioProvider } from '../providers/hinario/hinario';
import { Facebook } from '@ionic-native/facebook';
import { ContribuaProvider } from '../providers/contribua/contribua';
import { EnqueteProvider } from '../providers/enquete/enquete';
import { Media, MediaObject } from '@ionic-native/media';
import { ContribuicoesProvider } from '../providers/contribuicoes/contribuicoes';
import { AcompanhamentoProvider } from '../providers/acompanhamento/acompanhamento';
import { OvelhinhasProvider } from '../providers/ovelhinhas/ovelhinhas';
import { TranslateService } from '@ngx-translate/core';
import { NomenclaturaPipe } from '../pipes/nomenclatura/nomenclatura';
import { ApplicationInitializerFactory } from '../translate/translation.config';
import { MultiigrejaProvider } from '../providers/multiigreja/multiigreja';
import { BarcodeScanner } from '@awesome-cordova-plugins/barcode-scanner/ngx';
import { SoreiSaishiProvider } from '../providers/sorei-saishi/sorei-saishi';
import { environment } from '../environments/environment';
import { NavProvider } from '../providers/nav/nav';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, environment.API_URL + '/translate?lang=');
}

@NgModule({
  declarations: [MyApp],
  imports: [
    SharedModule,
    BrowserModule,
    BrowserAnimationsModule,
    DatePickerModule,
    IonicModule.forRoot(MyApp, {
      backButtonText: '',
      backButtonIcon: 'close',
      iconMode: 'md',
      modalEnter: 'modal-slide-in',
      modalLeave: 'modal-slide-out',
      tabsPlacement: 'bottom',
      pageTransition: 'ios-transition',
    }),
    IonicStorageModule.forRoot(),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: CustomMissingTranslationHandler,
        deps: [NotTranslatedProvider],
      },
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [IonicApp],
  entryComponents: [MyApp],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorProvider, multi: true },
    InterceptorProvider,
    UserProvider,
    ConfigProvider,
    InstituicaoProvider,
    EventoProvider,
    PessoaProvider,
    BibliaProvider,
    GrupoProvider,
    MdaProvider,
    CultoProvider,
    MensagemProvider,
    OracaoProvider,
    EnderecoProvider,
    Camera,
    Push,
    BarcodeScanner,
    NotTranslatedProvider,
    SantoProvider,
    Geolocation,
    SolicitacaoProvider,
    SoreiSaishiProvider,
    MapaProvider,
    NoticiaProvider,
    Calendar,
    MultiigrejaProvider,
    CadastroProvider,
    AplicativoProvider,
    AnimationService,
    EscalaProvider,
    HinarioProvider,
    Facebook,
    Media,
    EnqueteProvider,
    ContribuaProvider,
    ContribuicoesProvider,
    NomenclaturaPipe,
    AcompanhamentoProvider,
    OvelhinhasProvider,
    NavProvider,
    {
      provide: APP_INITIALIZER,
      useFactory: ApplicationInitializerFactory,
      deps: [TranslateService, Injector],
      multi: true,
    },
  ],
  exports: [],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts